import * as amplitude from "@amplitude/analytics-browser";
import { getKorDate } from "./date";
import { TAttendeeLimit } from "apis/meetings/meeting-room";
import { TExtendedMeetingRoom } from "apis/meeting-room-device";

export class AmplitudeService {
  constructor() {}

  //* INFO: 노쇼 예약 목록 조회 로그 (https://www.notion.so/mile-corporation/152a222a9c1b80c58a1ace25b070bd7f)
  async trackingGetNoshowList(
    workspaceId: string,
    workspaceName: string,
    viewStartDate: Date,
    viewEndDate: Date,
    cancelAbilityIdList: string[],
    page: number
  ) {
    if (process.env.REACT_APP_AMPLITUDE_API_KEY === undefined || process.env.REACT_APP_AMPLITUDE_API_KEY === "") {
      return;
    }
    try {
      amplitude.init(`${process.env.REACT_APP_AMPLITUDE_API_KEY}`);
      amplitude.track(
        "노쇼 예약 목록 조회",
        {
          dateTime: new Date(),
          workspaceId: workspaceId,
          workspaceName: workspaceName,
          viewStartDate: getKorDate(viewStartDate.toISOString()).replaceAll(".", "-"),
          viewEndDate: getKorDate(viewEndDate.toISOString()).replaceAll(".", "-"),
          cancelabilityIdList: cancelAbilityIdList,
          page: page,
        },
        {
          user_id: workspaceId,
        }
      );
    } catch (error) {
      console.log(error);
    }
  }

  //* INFO: 노쇼 예약 상세 정보 조회 로그 (https://www.notion.so/mile-corporation/152a222a9c1b80c58a1ace25b070bd7f)
  async trackingGetNoshowDetailInfo(
    workspaceId: string,
    workspaceName: string,
    instanceId: string,
    isRecurring: boolean,
    noshowNum: number
  ) {
    if (process.env.REACT_APP_AMPLITUDE_API_KEY === undefined || process.env.REACT_APP_AMPLITUDE_API_KEY === "") {
      return;
    }
    try {
      amplitude.init(`${process.env.REACT_APP_AMPLITUDE_API_KEY}`);
      amplitude.track(
        "노쇼 예약 상세 정보 조회",
        {
          dateTime: new Date(),
          workspaceId: workspaceId,
          workspaceName: workspaceName,
          meetingReservationId: instanceId,
          isRecurring: isRecurring,
          noshowNum: noshowNum,
        },
        {
          user_id: workspaceId,
        }
      );
    } catch (error) {
      console.log(error);
    }
  }

  //* INFO: 노쇼 반복 예약 취소 로그 (https://www.notion.so/mile-corporation/152a222a9c1b80c58a1ace25b070bd7f)
  async trackingCancelNoshow(
    workspaceId: string,
    workspaceName: string,
    instanceId: string,
    noshowNum: number,
    page: "LIST" | "DETAIL",
    recurrenceCreatedAt: string,
    recurrenceTerminatedAt: string,
    recurrence: string,
    totalNoshowNum: number
  ) {
    if (process.env.REACT_APP_AMPLITUDE_API_KEY === undefined || process.env.REACT_APP_AMPLITUDE_API_KEY === "") {
      return;
    }
    try {
      amplitude.init(`${process.env.REACT_APP_AMPLITUDE_API_KEY}`);
      amplitude.track(
        "노쇼 반복 예약 취소",
        {
          dateTime: new Date(),
          workspaceId: workspaceId,
          workspaceName: workspaceName,
          page: page,
          meetingReservationId: instanceId,
          recurrenceCreatedAt: recurrenceCreatedAt,
          recurrenceTerminatedAt: recurrenceTerminatedAt,
          recurrence: recurrence,
          noshowNum: noshowNum,
          totalNoshowNum: totalNoshowNum,
        },
        {
          user_id: workspaceId,
        }
      );
    } catch (error) {
      console.log(error);
    }
  }

  //* INFO: 노쇼 반복 예약 취소 요청 로그 (https://www.notion.so/mile-corporation/152a222a9c1b80c58a1ace25b070bd7f)
  async trackingRequestCancelNoshow(
    workspaceId: string,
    workspaceName: string,
    instanceId: string,
    noshowNum: number,
    page: "LIST" | "DETAIL",
    recurrenceCreatedAt: string,
    recurrenceTerminatedAt: string,
    recurrence: string,
    totalNoshowNum: number
  ) {
    if (process.env.REACT_APP_AMPLITUDE_API_KEY === undefined || process.env.REACT_APP_AMPLITUDE_API_KEY === "") {
      return;
    }
    try {
      amplitude.init(`${process.env.REACT_APP_AMPLITUDE_API_KEY}`);
      amplitude.track(
        "노쇼 반복 예약 취소 요청",
        {
          dateTime: new Date(),
          workspaceId: workspaceId,
          workspaceName: workspaceName,
          page: page,
          meetingReservationId: instanceId,
          recurrenceCreatedAt: recurrenceCreatedAt,
          recurrenceTerminatedAt: recurrenceTerminatedAt,
          recurrence: recurrence,
          noshowNum: noshowNum,
          totalNoshowNum: totalNoshowNum,
        },
        {
          user_id: workspaceId,
        }
      );
    } catch (error) {
      console.log(error);
    }
  }

  //* INFO: 회의실별 최소 참석 인원 설정 로그 (https://www.notion.so/mile-corporation/1a1a222a9c1b8009833bfb0efdd9339a)
  async trackingSetMeetingRoomAttendeeLimit(
    workspaceId: string,
    workspaceName: string,
    meetingRoomId: string,
    meetingRoomName: string,
    attendanceSettings: TAttendeeLimit[]
  ) {
    if (process.env.REACT_APP_AMPLITUDE_API_KEY === undefined || process.env.REACT_APP_AMPLITUDE_API_KEY === "") {
      return;
    }
    try {
      amplitude.init(`${process.env.REACT_APP_AMPLITUDE_API_KEY}`);
      amplitude.track(
        "회의실별 최소 참석 인원 설정",
        {
          dateTime: new Date(),
          workspaceId: workspaceId,
          workspaceName: workspaceName,
          meetingRoomId: meetingRoomId,
          meetingRoomName: meetingRoomName,
          attendanceSettings: attendanceSettings,
        },
        {
          user_id: workspaceId,
        }
      );
    } catch (error) {
      console.log(error);
    }
  }

  //* INFO: [마일] 피크시간 최소 참석 제한 예약 차단 로그 (https://www.notion.so/mile-corporation/1a1a222a9c1b8009833bfb0efdd9339a)
  async logPeakTimeMinAttendanceReservationBlock(
    workspaceId: string,
    workspaceName: string,
    meetingRoomId: string,
    meetingRoomName: string,
    attemptedAction: "예약" | "수정",
    minAttendeeNum: number,
    creatorId: string,
    creatorEmail: string,
    attendeesId: string[]
  ) {
    if (process.env.REACT_APP_AMPLITUDE_API_KEY === undefined || process.env.REACT_APP_AMPLITUDE_API_KEY === "") {
      return;
    }
    try {
      amplitude.init(`${process.env.REACT_APP_AMPLITUDE_API_KEY}`);
      amplitude.track(
        "[마일] 피크시간 최소 참석 제한 예약 차단 로그",
        {
          dateTime: new Date(),
          workspaceId: workspaceId,
          workspaceName: workspaceName,
          meetingRoomId: meetingRoomId,
          meetingRoomName: meetingRoomName,
          attemptedAction: attemptedAction,
          minAttendeeNum: minAttendeeNum,
          creatorId: creatorId,
          creatorEmail: creatorEmail,
          attendeesId: attendeesId,
        },
        {
          user_id: workspaceId,
        }
      );
    } catch (error) {
      console.log(error);
    }
  }

  //* INFO: 최소 참석 예외 예약 로그 (https://www.notion.so/mile-corporation/1a1a222a9c1b8009833bfb0efdd9339a)
  async logMinAttendanceExceptionReservation(
    workspaceId: string,
    workspaceName: string,
    meetingRoomId: string,
    meetingRoomName: string,
    attemptedAction: "예약" | "수정",
    minAttendeeNum: number,
    creatorId: string,
    creatorEmail: string,
    attendeesId: string[]
  ) {
    if (process.env.REACT_APP_AMPLITUDE_API_KEY === undefined || process.env.REACT_APP_AMPLITUDE_API_KEY === "") {
      return;
    }
    try {
      amplitude.init(`${process.env.REACT_APP_AMPLITUDE_API_KEY}`);
      amplitude.track(
        "최소 참석 예외 예약",
        {
          dateTime: new Date(),
          workspaceId: workspaceId,
          workspaceName: workspaceName,
          meetingRoomId: meetingRoomId,
          meetingRoomName: meetingRoomName,
          attemptedAction: attemptedAction,
          minAttendeeNum: minAttendeeNum,
          creatorId: creatorId,
          creatorEmail: creatorEmail,
          attendeesId: attendeesId,
        },
        {
          user_id: workspaceId,
        }
      );
    } catch (error) {
      console.log(error);
    }
  }

  //* INFO: 최소 참석 제한 위반 예약 조회 (https://www.notion.so/mile-corporation/1a1a222a9c1b8009833bfb0efdd9339a)
  async logMinAttendanceViolationReservationQuery(
    workspaceId: string,
    workspaceName: string,
    viewStartDate: Date,
    viewEndDate: Date,
    page: number
  ) {
    if (process.env.REACT_APP_AMPLITUDE_API_KEY === undefined || process.env.REACT_APP_AMPLITUDE_API_KEY === "") {
      return;
    }
    try {
      amplitude.init(`${process.env.REACT_APP_AMPLITUDE_API_KEY}`);
      amplitude.track(
        "최소 참석 제한 위반 예약 조회",
        {
          dateTime: new Date(),
          workspaceId: workspaceId,
          workspaceName: workspaceName,
          viewStartDate: getKorDate(viewStartDate.toISOString()).replaceAll(".", "-"),
          viewEndDate: getKorDate(viewEndDate.toISOString()).replaceAll(".", "-"),
          page: page,
        },
        {
          user_id: workspaceId,
        }
      );
    } catch (error) {
      console.log(error);
    }
  }

  //* INFO: 회의실 기기 관리 페이지 조회 (https://www.notion.so/mile-corporation/1b5a222a9c1b8038b4bdf508a6d4226c)
  async logMeetingRoomDeviceManagementPageView(
    workspaceId: string,
    workspaceName: string,
    meetingRoomDevice: TExtendedMeetingRoom[]
  ) {
    if (process.env.REACT_APP_AMPLITUDE_API_KEY === undefined || process.env.REACT_APP_AMPLITUDE_API_KEY === "") {
      return;
    }

    let warningMeetingRooms = meetingRoomDevice.filter((meetingRoom) => {
      if (
        meetingRoom.meetingRoomDevices.length === 0 ||
        meetingRoom.meetingRoomDevices.some((device) => device.isBatteryCharging === false)
      ) {
        return meetingRoom;
      }
    });

    try {
      amplitude.init(`${process.env.REACT_APP_AMPLITUDE_API_KEY}`);
      amplitude.track(
        "회의실 기기 관리 페이지 조회",
        {
          dateTime: new Date(),
          workspaceId: workspaceId,
          workspaceName: workspaceName,
          usageMedium: "WEB",
          deviceWarningList: warningMeetingRooms.map((meetingRoom) => {
            return {
              meetingRoomId: meetingRoom.id,
              meetingRoomName: meetingRoom.name,
              meetingRoomDevices: meetingRoom.meetingRoomDevices.map((device) => {
                return {
                  deviceId: device.id,
                  deviceBatteryLevel: device.batteryLevel,
                  isBatteryCharging: device.isBatteryCharging,
                };
              }),
            };
          }),
        },
        {
          user_id: workspaceId,
        }
      );
    } catch (error) {
      console.log(error);
    }
  }
}
